import { Routes, Route, Navigate } from "react-router-dom";
import { useEffect } from "react";
import { message, ConfigProvider } from "antd";

import Certificates from './pages/Certificates/Certificates';
import CertificatePage from './pages/Certificates/CertificatePage';
import SettingsPage from './pages/Settings/SettingsPage';
import Objects from './pages/Equipment/Objects';
import ObjectPage from './pages/Equipment/ObjectPage';
import EquipmentPage from './pages/Equipment/EquipmentPage';
import MyProfile from './pages/Profile/MyProfile';
import AppLayout from './components/Layout';
import { BitrixProvider, useBitrix } from './context/BitrixContext';
import ExcelUpload from "./components/ExcelUpload";
import { useAutoPreventBodyScroll } from './hooks/usePreventBodyScroll';

const AppRoutes = () => {
  const [messageApi, contextHolder] = message.useMessage();
  const { user, loading } = useBitrix();

  // Prevent body scroll on mobile when dropdowns are open
  useAutoPreventBodyScroll();

  // Hardcode: Prevent page scroll when scrolling inside dropdown/modal on mobile
  useEffect(() => {
    const handleTouchMove = (e) => {
      // Check if touch is inside a dropdown, modal, or other scrollable container
      const isInsideDropdown = e.target.closest(
        '.ant-select-dropdown, .ant-picker-dropdown, .ant-dropdown, .ant-modal-content, .ant-popover-inner'
      );
      
      if (isInsideDropdown) {
        // Allow the scroll to happen inside the dropdown
        return;
      }
      
      // For everything else, check if we're on mobile
      const isMobile = window.innerWidth <= 768;
      if (!isMobile) return;
      
      // Check if a modal or dropdown is open
      const hasModal = document.querySelector('.ant-modal:not(.ant-modal-hidden)');
      const hasDropdown = document.querySelector(
        '.ant-select-dropdown:not(.ant-select-dropdown-hidden), ' +
        '.ant-picker-dropdown:not(.ant-picker-dropdown-hidden), ' +
        '.ant-dropdown:not(.ant-dropdown-hidden)'
      );
      
      if (hasModal || hasDropdown) {
        e.preventDefault();
      }
    };

    document.addEventListener('touchmove', handleTouchMove, { passive: false });
    return () => document.removeEventListener('touchmove', handleTouchMove);
  }, []);

  // Show message only when user exists and context is inserted
  useEffect(() => {
    if (user) {
      messageApi.success(`Добро пожаловать, ${user.NAME || "Пользователь"}!`);
        console.log(user)

    }
  }, [user, messageApi]);

  // Don't return plain <p> — keep layout so contextHolder is in the tree
  if (loading) return (
    <AppLayout>
      {contextHolder}
      <p>Загрузка...</p>
    </AppLayout>
  );

  if (!user) return (
    <AppLayout>
      {contextHolder}
      <p>Не удалось получить пользователя Bitrix24</p>
    </AppLayout>
  );

  return (
    <ConfigProvider
      select={{
        // Improve mobile experience
        dropdownMatchSelectWidth: true,
      }}
      theme={{
        components: {
          Select: {
            // Prevent dropdown from causing page scroll
            zIndexPopup: 1050,
          },
        },
      }}
    >
      <AppLayout>
        {contextHolder}
        <Routes>
          <Route path="/" element={<Navigate to="/certificates" />} />
          <Route path="/certificates" element={<Certificates />} />
          <Route path="/certificates/:id" element={<CertificatePage />} />
          <Route path="/objects" element={<Objects />} />
          <Route path="/settings" element={<SettingsPage />} />
          <Route path="/profile" element={<MyProfile />} />
          <Route path="/objects/:objectId" element={<ObjectPage />} />
          <Route path="/objects/:objectId/equipment/:equipmentId/" element={<EquipmentPage />} />
        </Routes>
      </AppLayout>
    </ConfigProvider>
  );
};

export default function App() {
  return (
    <BitrixProvider>
      <AppRoutes />
    </BitrixProvider>
  );
}
